"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryGetIsoCode = void 0;
const country_id_iso_code_mapping_1 = require("./country-id-iso-code-mapping");
const isoCodesById = new Map(country_id_iso_code_mapping_1.idIsoCodeMapping.map(i => [i.id, i.isoCode]));
const countryGetIsoCode = (id) => {
    var _a;
    return (_a = isoCodesById.get(id)) !== null && _a !== void 0 ? _a : null;
};
exports.countryGetIsoCode = countryGetIsoCode;
//# sourceMappingURL=country-get-iso-code.js.map